import app, { Component } from 'apprun';
import { companies as objApi } from '../api';
/* eslint-disable */

export default class CommonPropertyComponent extends Component {

  view = (state) => {
    if (!state.item) {return;}
    return (
      <form class="form-horizontal" style={{ width: '450px' }}>
        <div class="row">
          <div class="col-sm-6">Year</div>
          <div class="col-sm-6">Month</div>
          {
            <div>
              <div class="col-sm-6">
                <select id="inpYearText" class="form-control" oninput={e => this.run('yearSelectionChanged', e.target.value)}>
                  {state.selectOptionsYears.map(p => (<option value={p}>{p}</option>))}
                </select>
              </div>

              <div class="col-sm-6">
                <select id="inpMonthText" class="form-control" oninput={e => (state.newVal = e.target.value)}>
                  {state.selectOptionsMonths.filter(p => p.startsWith(state.yearSelected)).map(p => (<option value={p}>{state.MonthNames[p.substr(5,2)]}</option>))}
                </select>
              </div>
            </div>
          }
        </div>
        <div id="inpTextErrMsg" class="text-danger"></div>
        <div class="edit-buttons">
          <a
            type="button"
            class="btn btn-primary btn-xs"
            style={
              state.item.required || state.item.value === ''
                ? { display: 'none' }
                : { display: 'inline-block' }
            }
            onclick={() => state.caller.run(state.delete, state.item, state.panelId)}>
            delete
          </a>
          <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('save')}>
            Download
          </a>
          <a
            type="button"
            class="btn btn-default btn-xs"
            onclick={() => state.caller.run(state.cancel, state.panelId)}>
            cancel
          </a>
        </div>
      </form>
    );
  };

  update = {
    refresh: async (state, newState) => {
      state = newState;

      state.MonthNames={ '':'', '01':'Jan','02':'Feb','03':'Mar','04':'Apr','05':'May','06':'Jun','07':'Jul','08':'Aug','09':'Sep','10':'Oct','11':'Nov','12':'Dec' };
      const selectOptionsMonths = await objApi.getRptAvailableMonths(state.companyId);

      const selectOptionsYears = Array.from(new Set(selectOptionsMonths.map(i =>  (i.substr(0,4)))));
      state.yearSelected=selectOptionsYears[0];
      state.newVal = (selectOptionsMonths.filter(p => p.startsWith(state.yearSelected)))[0];

      return { ...state, selectOptionsYears, selectOptionsMonths};
    },

    yearSelectionChanged: async (state, idx) => {
      state.yearSelected=idx;
      state.newVal = (state.selectOptionsMonths.filter(p => p.startsWith(state.yearSelected)))[0];
      return state;
    },

    save: (state) => {
      if((state.newVal !== '') && (!state.newVal.includes('Select'))){
        state.caller.run(state.save, state.item, state.panelId, state.newVal);
      }
    }
  };

  mounted = ({ state }) => {
    this.run('refresh', state);
  };
}
